export default __webpack_public_path__ + "a64a3d2a61ada29adcc9e8a1ffa49548.png";